import InboxMembersAPI from '../../api/inboxMembers';

export const actions = {
  get(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  create(_, { inboxId, agentList, autoAssignmentSettings }) {
    return InboxMembersAPI.update({
      inboxId,
      agentList,
      autoAssignmentSettings,
    });
  },
};

export default {
  namespaced: true,
  actions,
};
